
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.237 14.237a1.75 1.75 0 000-2.474L3.101.626A1.75 1.75 0 10.626 3.1l9.9 9.899-9.9 9.9A1.75 1.75 0 003.1 25.373l11.136-11.137zM12 14.75h1v-3.5h-1v3.5z","fill":"#585858"}})])
          )
        }
      }
    